import { parse } from "date-fns";

/**
 *
 * @param value DateString
 * @returns string
 */

function parseDatetime(value = "") {
  return value.length
    ? parse(value, "dd/MM/yyyy HH:mm:ss", new Date()).toISOString()
    : null;
}

export default parseDatetime;
